import { useEffect } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import Differentials from "../components/Differentials";
import Partners from "../components/Partners";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import WhatsAppFloat from "../components/WhatsAppFloat";
import { useScrollReveal } from "../lib/hooks";

export default function LandingPage() {
  useScrollReveal();

  useEffect(() => {
    document.title = "Master Business Consultoria Contábil | Contabilidade Estratégica em Goiânia";
    const desc = document.querySelector("meta[name='description']");
    const content =
      "Master Business Consultoria Contábil — Contabilidade estratégica em Goiânia. Escrituração, Departamento Pessoal, Fiscal, Perícia e mais. Atendimento humanizado.";
    if (desc) desc.setAttribute("content", content);
    else {
      const m = document.createElement("meta");
      m.name = "description";
      m.content = content;
      document.head.appendChild(m);
    }
  }, []);

  return (
    <main className="bg-[#F5F7FA]">
      <Header />
      <Hero />
      <About />
      <Services />
      <Differentials />
      <Partners />
      <Contact />
      <Footer />
      <WhatsAppFloat />
    </main>
  );
}
